document.addEventListener('DOMContentLoaded', function(){
  let swiperGameSlider = new Swiper('.game-single-slider',{
    loop: true,
    slidesPerView: 1,
    speed: 400,
    KeyboardControl: true,
    navigation:{
      nextEl: '.swiper-game-next',
      prevEl: '.swiper-game-prev',
    },
    keyboard: {
      enable: true,
      onlyInViewport: true,
    }
  });
});
